var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-goods-qr-code',{ref:"table",staticClass:"pt-goods-qr-code__withData",on:{"deleteQrCode":_vm.deleteQrCode,"downloadQrCode":_vm.downloadQrCode}})}
var staticRenderFns = []

export { render, staticRenderFns }